export const ROLE_ADMIN = 'Admin'
export const ROLE_KOPRAL = 'Kopral'
export const ROLE_SERSAN = 'Sersan'
export const ROLE_MAYOR = 'Mayor'
export const ROLE_PRO = 'Pro'
export const ROLE_BASIC = 'Basic'
export const STATUS_ACCOUNT_ACTIVE = 'active'
export const STATUS_ACCOUNT_INACTIVE = 'inactive'
export const STATUS_ACCOUNT_VERIFY = 'verify'